import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { MatDividerModule } from '@angular/material/divider'
import { MatSelectModule } from '@angular/material/select'
import { OverviewComponent } from '@shared-ui-lib/overview/overview.component'

@NgModule({
    declarations: [OverviewComponent],
    exports: [OverviewComponent],
    imports: [CommonModule, MatDividerModule, MatSelectModule],
})
export class OverviewModule {}
